"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelFieldSubFormInstance = exports.CollectionModelBase = void 0;
var tslib_1 = require("tslib");
var collection_field_1 = require("./collection.field");
var field_factory_1 = require("./fields/field.factory");
var form_field_1 = require("./fields/form.field");
var location_field_1 = require("./fields/location.field");
var true_size_field_1 = require("./fields/true.size.field");
var CollectionModelBase = /** @class */ (function () {
    function CollectionModelBase(parent, id, schema) {
        this.fields = {};
        this.parent = parent;
        this.schema = schema;
        if (id != null) {
            this.instanceId = id;
        }
    }
    Object.defineProperty(CollectionModelBase.prototype, "instanceId", {
        get: function () {
            return this._instanceId;
        },
        set: function (value) {
            this._instanceId = value;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelBase.prototype.getField = function (fieldId) {
        var field = this.fields[fieldId];
        if (field == null) {
            var fieldSchema = this.schema.getField(fieldId);
            if (fieldSchema == null) {
                throw new Error("Unable to find field ".concat(this.instanceId, ".").concat(fieldId));
            }
            field = field_factory_1.FieldFactory.create(this, fieldSchema);
            this.fields[fieldId] = field;
        }
        return field;
    };
    CollectionModelBase.prototype.getOptionalField = function (fieldId) {
        var field = this.fields[fieldId];
        if (field == null) {
            var fieldSchema = this.schema.getField(fieldId);
            if (fieldSchema == null) {
                return null;
            }
            field = field_factory_1.FieldFactory.create(this, fieldSchema);
            this.fields[fieldId] = field;
        }
        return field;
    };
    CollectionModelBase.prototype.getFields = function () {
        var _this = this;
        return this.schema.fields.map(function (field) { return _this.fields[field.id]; });
    };
    CollectionModelBase.prototype.getFieldDeep = function (fieldId) {
        var result;
        this.forEachField(function (x) {
            if (fieldId === x.id) {
                result = x;
            }
        });
        return result;
    };
    CollectionModelBase.prototype.hasField = function (fieldId) {
        return this.fields[fieldId] != null || this.collection.state.hasFieldValue(collection_field_1.CollectionModelField.getStateId(this, fieldId));
    };
    Object.defineProperty(CollectionModelBase.prototype, "title", {
        get: function () {
            var titleField = this.schema.titleField;
            if (titleField == null) {
                return this.formTitle;
            }
            var titleCollectionField = this.getField(titleField.id);
            if (!titleCollectionField.hasValue() || titleCollectionField.displayValue == null || titleCollectionField.displayValue === '') {
                return this.formTitle;
            }
            return titleCollectionField.displayValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelBase.prototype, "titleField", {
        get: function () {
            var titleField = this.schema.titleField;
            return titleField.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelBase.prototype, "subtitle", {
        get: function () {
            var subtitleField = this.schema.subtitleField;
            if (subtitleField == null) {
                return null;
            }
            var subtitleCollectionField = this.getField(subtitleField.id);
            if (!subtitleCollectionField.hasValue() || subtitleCollectionField.displayValue == null || subtitleCollectionField.displayValue === '') {
                return null;
            }
            return subtitleCollectionField.displayValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelBase.prototype, "siteType", {
        get: function () {
            var siteTypeField = this.schema.siteTypeField;
            if (siteTypeField == null) {
                return null;
            }
            var siteTypeCollectionField = this.getField(siteTypeField.id);
            if (!siteTypeCollectionField.hasValue() || siteTypeCollectionField.displayValue == null || siteTypeCollectionField.displayValue === '') {
                return null;
            }
            return siteTypeCollectionField.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelBase.prototype, "dropPole", {
        get: function () {
            var dropPoleField = this.schema.dropPoleField;
            if (dropPoleField == null) {
                return null;
            }
            var dropPoleCollectionField = this.getField(dropPoleField.id);
            if (!dropPoleCollectionField.hasValue() || dropPoleCollectionField.displayValue == null || dropPoleCollectionField.displayValue === '') {
                return null;
            }
            return dropPoleCollectionField.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelBase.prototype, "poleLoading", {
        get: function () {
            var poleLoadingField = this.schema.poleLoadingField;
            if (poleLoadingField == null) {
                return null;
            }
            var poleLoadingCollectionField = this.getField(poleLoadingField.id);
            if (!poleLoadingCollectionField.hasValue() || poleLoadingCollectionField.displayValue == null || poleLoadingCollectionField.displayValue === '') {
                return null;
            }
            return poleLoadingCollectionField.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelBase.prototype, "location", {
        /**
         * Return the first location found in the collection.
         * This is either the first location field or, if none exists, the first truesize image’s location is used.
         */
        get: function () {
            var result = {
                locationValue: null,
                trueSizeValue: null
            };
            this.forEachField(function (field) {
                if (location_field_1.CollectionModelFieldLocation.isLocationField(field) && field.hasValue()) {
                    result.locationValue = field.value;
                    return false; // break the loop early
                }
                if (result.trueSizeValue == null && true_size_field_1.CollectionModelFieldTrueSize.isTrueSizeField(field)) {
                    var captures = field.getCaptures();
                    if (captures.length > 0) {
                        result.trueSizeValue = captures[0].target;
                    }
                }
                return true;
            });
            return result.locationValue || result.trueSizeValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelBase.prototype, "locationModelField", {
        /**
         * Returns the location field found in the collection
         * This is either in the first location field or, if none exists, the first truesize image is used.
         */
        get: function () {
            var result = {
                location: null,
                truesize: null
            };
            this.forEachField(function (field) {
                if (location_field_1.CollectionModelFieldLocation.isLocationField(field) && field.hasValue()) {
                    result.location = field;
                    return false;
                }
                return true;
            });
            if (!result.location) {
                this.forEachField(function (field) {
                    if (!result.truesize && true_size_field_1.CollectionModelFieldTrueSize.isTrueSizeField(field)) {
                        result.truesize = field;
                        return false;
                    }
                    return true;
                });
            }
            return result.location || result.truesize;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelBase.prototype, "editableLocationField", {
        /**
         * Get the first location field (not value) in the form (not truesize)
         */
        get: function () {
            var locationField = null;
            this.forEachField(function (field) {
                if (location_field_1.CollectionModelFieldLocation.isLocationField(field)) {
                    locationField = field;
                    return false; // break loop after location is found
                }
                return true;
            });
            return locationField;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Iterate over all fields in the collection,
     * This will do a depth first traversal.
     *
     * Returning false at any stage will abort the traversal.
     *
     * @param func Function to call on every field.
     * @returns Whether all fields were processed
     */
    CollectionModelBase.prototype.forEachField = function (func) {
        var e_1, _a, e_2, _b;
        try {
            for (var _c = tslib_1.__values(this.schema.fields), _d = _c.next(); !_d.done; _d = _c.next()) {
                var schema = _d.value;
                var collectionField = this.getField(schema.id);
                var result = func(collectionField);
                if (result === false) {
                    return false;
                }
                if (form_field_1.CollectionModelFieldSubForm.isSubFormField(collectionField)) {
                    try {
                        for (var _e = (e_2 = void 0, tslib_1.__values(collectionField.value)), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var instance = _f.value;
                            var res = instance.forEachField(func);
                            if (res === false) {
                                return false;
                            }
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return true;
    };
    Object.defineProperty(CollectionModelBase.prototype, "formTitle", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    return CollectionModelBase;
}());
exports.CollectionModelBase = CollectionModelBase;
var CollectionModelFieldSubFormInstance = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelFieldSubFormInstance, _super);
    function CollectionModelFieldSubFormInstance(parent, id, schema) {
        return _super.call(this, parent, id, schema) || this;
    }
    Object.defineProperty(CollectionModelFieldSubFormInstance.prototype, "collection", {
        get: function () {
            return this.parent.collection;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldSubFormInstance.prototype, "formTitle", {
        get: function () {
            var name = this.schema.displayName || '';
            var parent = this.parent;
            var index = parent.value.indexOf(this);
            return "".concat(name, " #").concat(index + 1);
        },
        enumerable: false,
        configurable: true
    });
    return CollectionModelFieldSubFormInstance;
}(CollectionModelBase));
exports.CollectionModelFieldSubFormInstance = CollectionModelFieldSubFormInstance;
//# sourceMappingURL=collection.base.js.map